import React, { FC } from 'react';

import { AccessByIdentityItem } from '@ariksa/inventory-core';

import { StackedCell } from 'components/DataDisplay';

import { GrantNameCell, GrantNameCellProps } from './GrantNameCell';
import { getGrantsSummary, hasManyGrants } from './utils';

interface GrantCellProps extends Omit<GrantNameCellProps, 'grant'> {
  row: AccessByIdentityItem;
}

/**
 * The Mechanism column: a single grant by name, or a count such as
 * "1 policy · via 2 roles" with the first grant's name below it. Expanding the
 * row lists every grant.
 */
export const GrantCell: FC<GrantCellProps> = props => {
  const { row, ...rest } = props;
  const grants = row?.grants ?? [];

  if (!hasManyGrants(row)) return <GrantNameCell grant={grants[0]} {...rest} />;

  return (
    <StackedCell
      upper={getGrantsSummary(grants)}
      lower={`${grants[0]?.name ?? '-'} +${grants.length - 1}`}
    />
  );
};
